import {CollapsibleRichText} from '@/components/richTextBlock/collapsibleRichText';
import {Logo} from '@/components/ui/logo/logo';
import {Typography} from '@/components/ui/typography';

interface WayraSaysCardProps {
  content: string;
  author: {
    firstName: string | null;
    avatarUrl: string | null;
  } | null;
}

/**
 * Editorial commentary block displayed on the event detail page.
 * Shows attributed editorial content with the author's avatar,
 * first name, and a Wayra badge. Falls back to "Wayra Says" if
 * no author data is available.
 */
export function WayraSaysCard({content, author}: WayraSaysCardProps) {
  const displayName = author?.firstName?.trim() || 'Wayra';

  return (
    <div className="rounded-xl border border-neutral-200 bg-neutral-100 p-5">
      <div className="flex items-center gap-3 mb-4">
        {author?.avatarUrl ? (
          <img
            src={author.avatarUrl}
            alt={displayName}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-neutral-300 flex items-center justify-center">
            <span className="text-sm font-semibold text-neutral-700">
              {displayName.charAt(0)}
            </span>
          </div>
        )}
        <div className="flex flex-col items-start gap-1">
          <div className="flex items-center gap-2">
            <Typography level="H4" className="italic font-semibold">
              {displayName} Says
            </Typography>
          </div>
          <Logo className="h-3.5 w-auto opacity-70" />
        </div>
      </div>
      <CollapsibleRichText
        html={content}
        className="text-gray-700 text-sm leading-relaxed [&_p]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-gray-900 [&_h2]:mb-1 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:text-gray-900 [&_h3]:mb-1"
      />
    </div>
  );
}
